//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "Number",
  props: {
    drawer: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      payment_method: null,
      payment_reference: null
    };
  }
};